import EditableText from "./EditableText";

const AI_VISUAL =
  "https://static.prod-images.emergentagent.com/jobs/a2630fa8-7512-4afc-8f34-38ff2529270f/images/79cd1f686e802017cb3140bb46697d61224d4f32bc46a2e942bac270947146dd.png";

const INSIGHTS = [
  "Your protein is too low for recovery this phase.",
  "Energy tends to drop in your luteal week — let's gentle-train.",
  "Cravings spike 3 days before your bleed. Try magnesium-rich swaps.",
  "Calorie intake above your fat-loss range. Adjusting tomorrow.",
];

export const AIInsights = () => {
  return (
    <section data-testid="ai-insights-section" className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#F4ECFF] overflow-hidden">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="relative aspect-square max-w-md mx-auto">
            <div
              className="absolute inset-0 rounded-full blur-3xl opacity-50 animate-pulse-soft"
              style={{ background: "radial-gradient(circle, #B87CFF 0%, transparent 65%)" }}
            />
            <img src={AI_VISUAL} alt="AI wellness aura" className="relative w-full h-full object-cover rounded-full" data-testid="ai-insights-visual" />
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <EditableText k="ai.eyebrow" fallback="Smart AI insights" className="eyebrow" data-testid="ai-insights-eyebrow" />
          <h2 className="editorial-display mt-5 text-4xl sm:text-5xl lg:text-6xl text-[#0B0A4A]" data-testid="ai-insights-heading">
            <EditableText k="ai.heading" fallback="She learns your body a little more every day." multiline />
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#0B0A4A]/75 font-sans max-w-xl" data-testid="ai-insights-subheading">
            <EditableText
              k="ai.subheading"
              fallback="Your dashboard becomes a quiet, intelligent mirror — surfacing patterns no spreadsheet could see, and gently nudging you toward what your body actually needs today."
              multiline
            />
          </p>

          <ul className="mt-9 space-y-3" data-testid="ai-insights-list">
            {INSIGHTS.map((line, i) => (
              <li
                key={i}
                data-testid={`ai-insight-${i}`}
                className="flex items-start gap-4 p-4 rounded-2xl bg-white/70 backdrop-blur-sm border border-[#E0D0F5] hover:border-[#3E1A7A]/40 transition-colors"
              >
                <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#3E1A7A] flex-shrink-0" />
                <span className="font-serif italic text-lg sm:text-xl text-[#0B0A4A] leading-snug">
                  "<EditableText k={`ai.insight.${i}`} fallback={line} />"
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AIInsights;
